<template>
  <limit-editor
    :service="lottoServiceInstance"
    :endpoint-config="endpointConfig"
    :preset-config="presetConfig"
  />
</template>

<script>
import lottoService from '@/service/lottoService'
import LimitEditor from './components/LimitEditor.vue'

const endpointConfig = {}
const presetConfig = {}

export default {
  name: 'LottoLimitView',
  components: {
    LimitEditor,
  },
  data() {
    return {
      lottoServiceInstance: lottoService,
      endpointConfig,
      presetConfig,
    }
  },
}
</script>
